import { alpha } from "@mui/material/styles";

const styles = (theme) => ({
  iconButton: {
    color: theme.palette.text.secondary,
    p: 0.25,
  },
  paper: {
    borderRadius: "14px",
    maxWidth: 380,
  },
  content: {
    p: 2,
  },
  titulo: {
    fontWeight: 800,
    fontSize: 15,
    mb: 0.5,
  },
  descricao: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    mb: 1.5,
  },
  boxIlustracao: {
    borderRadius: "10px",
    backgroundColor: alpha(theme.palette.text.primary, 0.03),
    p: 1,
  },
  legenda: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    mt: 0.5,
    mb: 1.5,
    textAlign: "center",
  },
  comoLerTitulo: {
    fontWeight: 700,
    fontSize: 11,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: theme.palette.text.secondary,
    mb: 0.5,
  },
  comoLerLista: {
    m: 0,
    pl: 2.2,
    gap: 0.5,
  },
  comoLerItem: {
    fontSize: 13,
    lineHeight: 1.35,
  },
  link: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
    fontSize: 13,
    fontWeight: 700,
  },
});

export default styles;
